import { render, staticRenderFns } from "./StudioPodcasts.vue?vue&type=template&id=0ef56cfc&scoped=true&"
import script from "./StudioPodcasts.vue?vue&type=script&lang=js&"
export * from "./StudioPodcasts.vue?vue&type=script&lang=js&"
import style0 from "./StudioPodcasts.vue?vue&type=style&index=0&id=0ef56cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef56cfc",
  null
  
)

export default component.exports